import React from 'react';
import { Rocket, Eye } from 'lucide-react';

const ChatGPTHero = ({ onGetStarted, onViewPlans }) => {
  return (
    <section className="relative bg-white py-20 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            ChatGPT Plus Access at 90% Less Cost
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            Get instant access to GPT-4o, o3, custom GPTs, and all premium ChatGPT Plus features through our shared subscription service.
          </p>
          
          <div className="inline-block bg-black text-white px-8 py-4 rounded-lg mb-12 font-semibold text-lg">
            Same ChatGPT Plus quality, 90% savings. Start from just $4.17/month.
          </div>
          
          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-12 mb-12">
            <div className="flex items-center justify-center md:justify-start">
              <span className="text-black mr-2 text-xl font-bold">✓</span>
              <div className="text-left">
                <div className="font-semibold text-gray-900">Instant Access</div>
                <div className="text-sm text-gray-600">Setup in under 5 minutes</div>
              </div>
            </div>
            
            <div className="flex items-center justify-center md:justify-start">
              <span className="text-black mr-2 text-xl font-bold">✓</span>
              <div className="text-left">
                <div className="font-semibold text-gray-900">Full Features</div>
                <div className="text-sm text-gray-600">GPT-4o, o3, plugins, custom GPTs</div>
              </div>
            </div>
            
            <div className="flex items-center justify-center md:justify-start">
              <span className="text-black mr-2 text-xl font-bold">✓</span>
              <div className="text-left">
                <div className="font-semibold text-gray-900">90% Savings</div>
                <div className="text-sm text-gray-600">From $4.17/month vs $25 official</div>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onGetStarted}
              className="bg-black text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transition-colors duration-200 flex items-center justify-center"
            >
              <Rocket className="mr-2 w-5 h-5" />
              Get ChatGPT Plus Now
            </button>
            
            <button
              onClick={onViewPlans}
              className="border-2 border-black text-black px-8 py-4 rounded-lg text-lg font-medium hover:bg-black hover:text-white transition-colors duration-200 flex items-center justify-center"
            >
              <Eye className="mr-2 w-5 h-5" />
              View Plans & Pricing
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChatGPTHero;